import { type FC, type ReactNode } from 'react';

import { mergeSx } from '../../../util/mui/sx';

import { GenericListCheckbox, type GenericListCheckboxProps } from './GenericListCheckbox';

export interface GenericListItemCheckboxProps extends Omit<
  GenericListCheckboxProps,
  'isIndeterminate' | 'state'
> {
  readonly tooltip?: ReactNode;
}

export const GenericListItemCheckbox: FC<GenericListItemCheckboxProps> = props => (
  <GenericListCheckbox
    {...props}
    sx={mergeSx(
      {
        '> *': {
          aspectRatio: '1',
          maxHeight: '100%',
          width: 'auto',
        },
        alignItems: 'center',
        aspectRatio: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        maxHeight: '100%',
        width: 'auto',
      },
      props.sx,
    )}
  />
);
